<form class="g-3 needs-validation" novalidate [formGroup]="frmFields" (ngSubmit)="onSubmit()">

  <!-- ═══ PERIOD OF COVER ═══ -->
  <div class="form_sections">
    <h4><u>Period of Cover</u></h4>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group w-100">
          <input type="text" formControlName="inception_date" placeholder="Cover From"
            class="form-control form-control-sm datepicker" matInput
            (focus)="coverFromDatepicker.open()" [matDatepicker]="coverFromDatepicker"
            [min]="minInceptionDate" [max]="maxInceptionDate"
            (dateChange)="onPolicyStartDateChange($event)"
            [ngClass]="{ 'is-invalid': (f.inception_date?.touched || submitted) && f.inception_date?.errors?.required }">
          <mat-datepicker-toggle [for]="coverFromDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #coverFromDatepicker></mat-datepicker>
          <div class="invalid-feedback" *ngIf="(f.inception_date?.touched || submitted) && f.inception_date?.errors?.required">
            Cover from date is required.
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group w-100">
          <input type="text" placeholder="Cover To" class="form-control form-control-sm datepicker"
            [value]="modelObj?.cover_to" disabled>
        </div>
      </div>
      <div class="col-md-6" *ngIf="!isBroker">
        <label><u>Broker Details</u></label>
        <mat-form-field style="width:93%">
          <mat-select formControlName="company_id" (selectionChange)="getBrokerCommission($event)"
            [ngClass]="{ 'is-invalid': (f.company_id?.touched || submitted) && f.company_id?.errors?.required }">
            <mat-option [value]="">Select Broker</mat-option>
            <mat-option *ngFor="let brk of brokers" [value]="brk.id">{{brk.name}}</mat-option>
          </mat-select>
          <div *ngIf="(f.company_id?.touched || submitted) && f.company_id?.errors?.required" class="invalid-feedback">
            Please select a broker.
          </div>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="this.modelObj && this.modelObj.type == 3 || quote_type == 3">
      <div class="col-md-6">
        <div class="form-group w-100">
          <label>MTA Effective Date</label><br>
          <input type="text" required name="effective_date" formControlName="effective_date"
            placeholder="MTA Effective Date" class="form-control form-control-sm datepicker" matInput
            (focus)="effectiveDateDatepicker.open()" [matDatepicker]="effectiveDateDatepicker"
            [min]="isEffectiveDatePast ? minEffectiveDate : f.inception_date.value" [max]="maxInceptionDate"
            [ngClass]="{ 'is-invalid': (f.effective_date.touched || submitted) && f.effective_date.errors?.required }">
          <mat-datepicker-toggle [for]="effectiveDateDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #effectiveDateDatepicker></mat-datepicker>
          <div class="invalid-feedback"
            *ngIf="(f.effective_date.touched || submitted) && f.effective_date.errors?.required">
            Effective date is required.
          </div>
          <mat-error class="invalid-feedback" *ngIf="f.effective_date.hasError('matDatepickerMin')">
            Please select the valid date.
          </mat-error>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ PROPOSER DETAILS ═══ -->
  <div class="form_sections" formGroupName="proposer">
    <h4><u>Proposer Details</u></h4>
    <p>Is the proposer a Company or an Individual? <span class="text-danger">*</span></p>
    <mat-radio-group class="row" formControlName="proposer_type" required (change)="onProposerChange($event)">
      <div class="col-md-4">
        <div class="quote_radio w-90"><mat-radio-button value="company">Company</mat-radio-button></div>
      </div>
      <div class="col-md-4">
        <div class="quote_radio w-90"><mat-radio-button value="individual">Individual</mat-radio-button></div>
      </div>
    </mat-radio-group>
    <div class="invalid-feedback" style="font-size:13px;"
      *ngIf="(proposerControls.proposer_type?.touched || submitted) && proposerControls.proposer_type?.errors?.required">
      Please select the proposer type.
    </div>

    <!-- ── COMPANY ── -->
    <div *ngIf="proposerControls.proposer_type?.value == 'company'">
      <h6 class="mt-3">Is this client a Micro-enterprise? <span class="text-danger">*</span></h6>
      <small>A Micro-enterprise has annual turnover / balance sheet of €2m or less and fewer than 10 employees.</small>
      <mat-radio-group class="row mt-2" formControlName="micro_enterprise">
        <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
        <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
      </mat-radio-group>
      <div class="invalid-feedback" style="font-size:13px;"
        *ngIf="(proposerControls.micro_enterprise?.touched || submitted) && proposerControls.micro_enterprise?.errors?.required">
        Please select an option.
      </div>

      <h6 class="mt-3">Company Details</h6>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input type="text" formControlName="company_name" placeholder="Company Name"
              class="form-control form-control-sm" required
              [ngClass]="{ 'is-invalid': (proposerControls.company_name?.touched || submitted) && proposerControls.company_name?.errors?.required }">
            <div class="invalid-feedback" *ngIf="(proposerControls.company_name?.touched || submitted) && proposerControls.company_name?.errors?.required">
              Company name is required.
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input type="text" formControlName="trading_name" placeholder="Trading Name (if different)"
              class="form-control form-control-sm">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <input type="text" formControlName="company_registration_number" placeholder="Company Registration Number"
              class="form-control form-control-sm">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input type="text" formControlName="year_established" placeholder="Year Established" maxlength="4"
              class="form-control form-control-sm" required
              [ngClass]="{ 'is-invalid': (proposerControls.year_established?.touched || submitted) && proposerControls.year_established?.errors?.required }">
            <div class="invalid-feedback" *ngIf="(proposerControls.year_established?.touched || submitted) && proposerControls.year_established?.errors?.required">
              Year established is required.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── INDIVIDUAL ── -->
    <div class="mt-3" *ngIf="proposerControls.proposer_type?.value == 'individual'">
      <h6>Individual Details</h6>
      <div class="row">
        <div class="col-md-3" *ngIf="staticData">
          <mat-form-field class="w-100">
            <mat-label>Title</mat-label>
            <mat-select formControlName="title" required
              [ngClass]="{ 'is-invalid': (proposerControls.title?.touched || submitted) && proposerControls.title?.errors?.required }">
              <mat-option *ngFor="let t of staticData.title_options" [value]="t">{{t}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback" *ngIf="(proposerControls.title?.touched || submitted) && proposerControls.title?.errors?.required">
            Title is required.
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group mt-1">
            <input type="text" formControlName="first_name" placeholder="First Name"
              class="form-control form-control-sm" required
              [ngClass]="{ 'is-invalid': (proposerControls.first_name?.touched || submitted) && proposerControls.first_name?.errors?.required }">
            <div class="invalid-feedback" *ngIf="(proposerControls.first_name?.touched || submitted) && proposerControls.first_name?.errors?.required">
              First name is required.
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <input type="text" formControlName="last_name" placeholder="Last Name"
              class="form-control form-control-sm" required
              [ngClass]="{ 'is-invalid': (proposerControls.last_name?.touched || submitted) && proposerControls.last_name?.errors?.required }">
            <div class="invalid-feedback" *ngIf="(proposerControls.last_name?.touched || submitted) && proposerControls.last_name?.errors?.required">
              Last name is required.
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group w-100 mt-2">
            <input type="text" formControlName="dob" placeholder="Date of Birth"
              class="form-control form-control-sm datepicker" matInput
              (focus)="dobDatepicker.open()" [matDatepicker]="dobDatepicker" [max]="maxDOB" required
              [ngClass]="{ 'is-invalid': (proposerControls.dob?.touched || submitted) && (proposerControls.dob?.errors?.required || proposerControls.dob?.errors?.matDatepickerMax) }">
            <mat-datepicker-toggle [for]="dobDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #dobDatepicker></mat-datepicker>
            <div class="invalid-feedback d-block" *ngIf="(proposerControls.dob?.touched || submitted) && proposerControls.dob?.errors?.required">
              Date of birth is required.
            </div>
            <div class="invalid-feedback d-block" *ngIf="(proposerControls.dob?.touched || submitted) && proposerControls.dob?.errors?.matDatepickerMax">
              Proposer must be at least 16 years old.
            </div>
          </div>
        </div>
        <div class="col-md-4" *ngIf="staticData">
          <mat-form-field class="w-100" floatLabel="always">
            <mat-label>Type of Licence</mat-label>
            <mat-select formControlName="licence_type" required
              [ngClass]="{ 'is-invalid': (proposerControls.licence_type?.touched || submitted) && proposerControls.licence_type?.errors?.required }">
              <mat-option *ngFor="let l of staticData.licence_types" [value]="l">{{l}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback d-block" *ngIf="(proposerControls.licence_type?.touched || submitted) && proposerControls.licence_type?.errors?.required">
            Type of licence is required.
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group w-100 mt-1">
            <input type="text" formControlName="licence_length" placeholder="Licence Held Since"
              class="form-control form-control-sm datepicker" matInput required
              (focus)="llDatepicker.open()" [matDatepicker]="llDatepicker"
              [ngClass]="{ 'is-invalid': (proposerControls.licence_length?.touched || submitted) && proposerControls.licence_length?.errors?.required }">
            <mat-datepicker-toggle [for]="llDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #llDatepicker></mat-datepicker>
            <div class="invalid-feedback" *ngIf="(proposerControls.licence_length?.touched || submitted) && proposerControls.licence_length?.errors?.required">
              Length licence held is required.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── CORRESPONDENCE ADDRESS (both types) ── -->
    <div *ngIf="proposerControls.proposer_type?.value">
      <h6 class="mt-3">Correspondence Address</h6>
      <div formGroupName="address">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <div class="input-group">
                <input type="text" formControlName="postcode" placeholder="Postcode"
                  class="form-control form-control-sm text-uppercase"
                  [matAutocomplete]="agAddressAuto"
                  #agPostcodeAutoTrigger="matAutocompleteTrigger"
                  [ngClass]="{ 'is-invalid': (frmFields.get('proposer.address.postcode')?.touched || submitted) && frmFields.get('proposer.address.postcode')?.errors?.required }">
                <div class="input-group-append">
                  <button type="button" class="btn btn-success btn-sm" (click)="lookupAddress()"
                    [disabled]="isLookingUpAddress">
                    <span *ngIf="isLookingUpAddress" class="spinner-border spinner-border-sm mr-1"></span>
                    <i class="mdi mdi-magnify" *ngIf="!isLookingUpAddress"></i> Lookup
                  </button>
                </div>
              </div>
              <div class="invalid-feedback d-block"
                *ngIf="(frmFields.get('proposer.address.postcode')?.touched || submitted) && frmFields.get('proposer.address.postcode')?.errors?.required">
                Postcode is required.
              </div>
              <div class="invalid-feedback d-block" *ngIf="addressLookupMessage">
                {{ addressLookupMessage }}
              </div>
              <!-- [value] deliberately stays the typed postcode: picking an address must
                   not replace the postcode in the box with the address text. -->
              <mat-autocomplete #agAddressAuto="matAutocomplete">
                <mat-option *ngFor="let addr of addressList"
                  [value]="frmFields.get('proposer.address.postcode')?.value"
                  (click)="selectAddress(addr)">
                  {{addr.l || (addr.formatted_address ? addr.formatted_address.join(', ') : '')}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input type="text" formControlName="line1" placeholder="Address Line 1"
                class="form-control form-control-sm" required
                [ngClass]="{ 'is-invalid': (frmFields.get('proposer.address.line1')?.touched || submitted) && frmFields.get('proposer.address.line1')?.errors?.required }">
              <div class="invalid-feedback" *ngIf="(frmFields.get('proposer.address.line1')?.touched || submitted) && frmFields.get('proposer.address.line1')?.errors?.required">
                Address line 1 is required.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <input type="text" formControlName="line2" placeholder="Address Line 2"
                class="form-control form-control-sm">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input type="text" formControlName="line3" placeholder="Address Line 3"
                class="form-control form-control-sm">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input type="text" formControlName="town" placeholder="Town"
                class="form-control form-control-sm">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <input type="text" formControlName="county" placeholder="County"
                class="form-control form-control-sm">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── CONVICTIONS (individual only) ── -->
    <div class="mt-3" *ngIf="proposerControls.proposer_type?.value == 'individual'">
      <h6>Has the proposer had any unspent major and/or more than 2 minor motoring convictions? <span class="text-danger">*</span></h6>
      <mat-radio-group class="row" formControlName="has_convictions" required (change)="onHaveConvictionsChange($event)">
        <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
        <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
      </mat-radio-group>
      <div class="invalid-feedback d-block" style="font-size:13px;"
        *ngIf="(proposerControls.has_convictions?.touched || submitted) && proposerControls.has_convictions?.errors?.required">
        Please select an option.
      </div>

      <div formArrayName="convictions"
        *ngIf="frmFields.get('proposer.has_convictions')?.value == 'Yes'"
        class="pl-4 pr-4 pt-0 pb-4 green_border_panel mt-3">
        <div *ngFor="let conviction of getConvictionsArray().controls; let ci = index">
          <div [formGroupName]="ci" class="mt-3">
            <u>Conviction {{ci + 1}}</u>
            <a (click)="removeConviction(ci)" class="btn btn-danger btn-sm p-1 ml-3" *ngIf="ci > 0">
              <i class="mdi mdi-delete"></i>
            </a>
            <div class="row mt-2">
              <div class="col-md-6" *ngIf="staticData">
                <mat-form-field class="w-100">
                  <mat-label>Conviction code</mat-label>
                  <mat-select formControlName="code" required (selectionChange)="onConvictionCodeChange(conviction)"
                    [ngClass]="{ 'is-invalid': (conviction.get('code')?.touched || submitted) && conviction.get('code')?.errors?.required }">
                    <mat-option *ngFor="let c of staticData.conviction_types" [value]="c.code">
                      {{c.code}} — {{c.description}}
                    </mat-option>
                  </mat-select>
                  <div class="invalid-feedback" *ngIf="(conviction.get('code')?.touched || submitted) && conviction.get('code')?.errors?.required">
                    Please select an option.
                  </div>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <div class="form-group w-100 mt-2">
                  <input type="text" formControlName="date" placeholder="Date of the conviction"
                    class="form-control form-control-sm datepicker" matInput
                    (focus)="convDatepicker.open()" [matDatepicker]="convDatepicker"
                    [ngClass]="{ 'is-invalid': (conviction.get('date')?.touched || submitted) && conviction.get('date')?.errors?.required }">
                  <mat-datepicker-toggle [for]="convDatepicker"></mat-datepicker-toggle>
                  <mat-datepicker #convDatepicker></mat-datepicker>
                  <div class="invalid-feedback" *ngIf="(conviction.get('date')?.touched || submitted) && conviction.get('date')?.errors?.required">
                    Date is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group w-100 mt-2">
                  <input type="number" formControlName="points" placeholder="Number of Points"
                    class="form-control form-control-sm" required
                    [ngClass]="{ 'is-invalid': (conviction.get('points')?.touched || submitted) && conviction.get('points')?.errors?.required }">
                  <div class="invalid-feedback" *ngIf="(conviction.get('points')?.touched || submitted) && conviction.get('points')?.errors?.required">
                    Number of points is required.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group w-100 mt-2">
                  <input type="number" formControlName="months_banned" placeholder="Months Banned"
                    class="form-control form-control-sm">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group w-100 mt-2">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text bg-success text-white">&pound;</span>
                    </div>
                    <input type="number" formControlName="fine" placeholder="Fine amount"
                      class="form-control form-control-sm" required
                      [ngClass]="{ 'is-invalid': (conviction.get('fine')?.touched || submitted) && conviction.get('fine')?.errors?.required }">
                  </div>
                  <div class="invalid-feedback" *ngIf="(conviction.get('fine')?.touched || submitted) && conviction.get('fine')?.errors?.required">
                    Amount is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a (click)="addConviction()" class="btn btn-success btn-sm">Add Conviction</a>
      </div>
    </div>

    <!-- ── TRADE & BUSINESS (both types) ── -->
    <div *ngIf="proposerControls.proposer_type?.value">
      <h6 class="mt-3">Trade &amp; Business</h6>
      <div class="row" *ngIf="staticData">
        <div class="col-md-6">
          <mat-form-field class="w-100">
            <mat-label>Agricultural Trade</mat-label>
            <mat-select formControlName="agricultural_trade" required
              [ngClass]="{ 'is-invalid': (proposerControls.agricultural_trade?.touched || submitted) && proposerControls.agricultural_trade?.errors?.required }">
              <mat-option value="">Select trade</mat-option>
              <mat-option *ngFor="let t of staticData.agricultural_trade_options" [value]="t">{{t}}</mat-option>
            </mat-select>
          </mat-form-field>
          <small>As this is an agricultural motor product, the agricultural trade will be the primary use of the vehicles.</small>
          <div class="invalid-feedback d-block" *ngIf="(proposerControls.agricultural_trade?.touched || submitted) && proposerControls.agricultural_trade?.errors?.required">
            Agricultural trade is required.
          </div>
        </div>
      </div>

      <h6 class="mt-3">Do you have any other trades? <span class="text-danger">*</span></h6>
      <mat-radio-group class="row" formControlName="has_additional_trades" (change)="onAdditionalTradesChange($event)">
        <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
        <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
      </mat-radio-group>

      <div class="invalid-feedback" style="font-size:13px;"
        *ngIf="(proposerControls.has_additional_trades?.touched || submitted) && proposerControls.has_additional_trades?.errors?.required">
        Please select an option.
      </div>

      <div *ngIf="proposerControls.has_additional_trades?.value == 'Yes'" class="mt-3">
        <p class="mb-2"><small>Please select every additional trade the proposer carries out. At least one is required.</small></p>
        <div class="row mb-2" *ngFor="let trade of modelObj?.additional_trades; let ti = index">
          <div class="col-md-5" *ngIf="staticData">
            <mat-form-field class="w-100">
              <mat-label>Additional Trade {{ti + 1}}</mat-label>
              <mat-select [(ngModel)]="modelObj.additional_trades[ti]" [ngModelOptions]="{standalone: true}" required
                [ngClass]="{ 'is-invalid': submitted && !trade }">
                <mat-option value="">Select</mat-option>
                <mat-option *ngFor="let t of staticData.additional_trade_options" [value]="t">{{t}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="invalid-feedback d-block" *ngIf="submitted && !trade">
              Please select a trade.
            </div>
          </div>
          <div class="col-md-2 mt-2">
            <a (click)="removeTrade(ti)" class="btn btn-danger btn-sm p-1"><i class="mdi mdi-delete"></i></a>
          </div>
        </div>
        <a (click)="addTrade()" class="btn btn-success btn-sm" *ngIf="modelObj?.additional_trades?.length < 10">
          <i class="mdi mdi-plus"></i> Add Another Trade
        </a>
        <div class="invalid-feedback d-block" *ngIf="submitted && !modelObj?.additional_trades?.length">
          Please add at least one additional trade.
        </div>
      </div>

      <div class="row mt-3" *ngIf="staticData">
        <div class="col-md-6">
          <mat-form-field class="w-100">
            <mat-label>Agricultural / Forestry Contracting Percentage</mat-label>
            <mat-select formControlName="contracting_percentage" required
              [ngClass]="{ 'is-invalid': (proposerControls.contracting_percentage?.touched || submitted) && proposerControls.contracting_percentage?.errors?.required }">
              <mat-option value="">Select percentage</mat-option>
              <mat-option *ngFor="let c of staticData.contracting_percentage_options" [value]="c">{{c}}</mat-option>
            </mat-select>
          </mat-form-field>
          <small>Select 'Whole-Farm Contracting' where the proposer is contracted to work solely on one farm.</small>
          <div class="invalid-feedback d-block" *ngIf="(proposerControls.contracting_percentage?.touched || submitted) && proposerControls.contracting_percentage?.errors?.required">
            Contracting percentage is required.
          </div>
        </div>
      </div>

      <div *ngIf="proposerControls.proposer_type?.value == 'individual'">
        <h6 class="mt-3">Are the vehicles on this quote used for business purposes?</h6>
        <mat-radio-group class="row" formControlName="business_use_declaration">
          <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
          <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
        </mat-radio-group>
      </div>
    </div>

  </div><!-- end formGroupName="proposer" -->

  <!-- ═══ CLAIMS ═══ -->
  <div class="form_sections" *ngIf="frmFields.get('proposer.proposer_type')?.value" formGroupName="proposer">
    <h6>During the past 3 years, has the proposer been involved in a motor accident or made a motor insurance claim? <span class="text-danger">*</span></h6>
    <mat-radio-group class="row" formControlName="has_claims" required (change)="onHaveClaimsChange($event)">
      <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
      <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
    </mat-radio-group>
    <div class="invalid-feedback" style="font-size:13px;"
      *ngIf="(proposerControls.has_claims?.touched || submitted) && proposerControls.has_claims?.errors?.required">
      Please select an option.
    </div>

    <div formArrayName="claims"
      *ngIf="frmFields.get('proposer.has_claims')?.value == 'Yes'"
      class="pl-4 pr-4 pt-0 pb-4 green_border_panel mt-3">
      <div *ngFor="let claim of getClaimsArray().controls; let cli = index">
        <div [formGroupName]="cli" class="mt-3">
          <u>Claim {{cli + 1}}</u>
          <a (click)="removeClaim(cli)" class="btn btn-danger btn-sm p-1 ml-3" *ngIf="cli > 0">
            <i class="mdi mdi-delete"></i>
          </a>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group w-100 mt-2">
                <input type="text" formControlName="date" placeholder="Date of claim"
                  class="form-control form-control-sm datepicker" matInput
                  (focus)="claimDatepicker.open()" [matDatepicker]="claimDatepicker"
                  [ngClass]="{ 'is-invalid': (claim.get('date')?.touched || submitted) && claim.get('date')?.errors?.required }">
                <mat-datepicker-toggle [for]="claimDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #claimDatepicker></mat-datepicker>
                <div class="invalid-feedback" *ngIf="(claim.get('date')?.touched || submitted) && claim.get('date')?.errors?.required">
                  Date is required.
                </div>
              </div>
            </div>
            <div class="col-md-4" *ngIf="staticData">
              <mat-form-field class="w-100">
                <mat-label>Type of incident</mat-label>
                <mat-select formControlName="incident_type" required
                  [ngClass]="{ 'is-invalid': (claim.get('incident_type')?.touched || submitted) && claim.get('incident_type')?.errors?.required }">
                  <mat-option *ngFor="let i of staticData.claim_types" [value]="i">{{i}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="invalid-feedback" *ngIf="(claim.get('incident_type')?.touched || submitted) && claim.get('incident_type')?.errors?.required">
                Type is required.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group w-100 mt-2">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                  </div>
                  <input type="number" formControlName="ad_cost" placeholder="AD claim cost"
                    class="form-control form-control-sm" required
                    (change)="calculateClaimTotal(claim)"
                    [ngClass]="{ 'is-invalid': (claim.get('ad_cost')?.touched || submitted) && claim.get('ad_cost')?.errors?.required }">
                </div>
                <div class="invalid-feedback" *ngIf="(claim.get('ad_cost')?.touched || submitted) && claim.get('ad_cost')?.errors?.required">
                  Amount is required.
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group w-100 mt-2">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                  </div>
                  <input type="number" formControlName="tp_cost" placeholder="TP claim cost"
                    class="form-control form-control-sm" required
                    (change)="calculateClaimTotal(claim)"
                    [ngClass]="{ 'is-invalid': (claim.get('tp_cost')?.touched || submitted) && claim.get('tp_cost')?.errors?.required }">
                </div>
                <div class="invalid-feedback" *ngIf="(claim.get('tp_cost')?.touched || submitted) && claim.get('tp_cost')?.errors?.required">
                  Amount is required.
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group w-100 mt-2">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-success text-white">&pound;</span>
                  </div>
                  <input type="number" formControlName="total_cost" placeholder="Total claim cost"
                    class="form-control form-control-sm" readonly>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <label>Was the driver at fault?</label>
              <mat-radio-group class="row" formControlName="at_fault" required>
                <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
                <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
              </mat-radio-group>
              <div class="invalid-feedback d-block" *ngIf="(claim.get('at_fault')?.touched || submitted) && claim.get('at_fault')?.errors?.required">
                Please select an option.
              </div>
            </div>
            <div class="col-md-4">
              <label>Is the claim still open?</label>
              <mat-radio-group class="row" formControlName="is_open" required>
                <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
                <div class="col-md-6"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
              </mat-radio-group>
              <div class="invalid-feedback d-block" *ngIf="(claim.get('is_open')?.touched || submitted) && claim.get('is_open')?.errors?.required">
                Please select an option.
              </div>
            </div>
          </div>
        </div>
      </div>
      <a (click)="addClaim()" class="btn btn-success btn-sm mt-3">Add Claim</a>
    </div>
  </div>

  <!-- ═══ RATING TYPE ═══ -->
  <div class="form_sections" *ngIf="frmFields.get('proposer.proposer_type')?.value">
    <h6>Is the expiring policy Fleet Experience or NCD Rated? <span class="text-danger">*</span></h6>
    <mat-radio-group class="row" formControlName="rating_type" required (change)="onRatingTypeChange($event)">
      <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="fleet">Fleet Experience</mat-radio-button></div></div>
      <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="ncd">NCD Rated</mat-radio-button></div></div>
      <!-- 'none' (not 'no_previous') — the agri-api rating_type enum is fleet|ncd|none -->
      <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="none">No Previous Agricultural Insurance</mat-radio-button></div></div>
    </mat-radio-group>
    <div class="invalid-feedback" style="font-size:13px;"
      *ngIf="(f.rating_type?.touched || submitted) && f.rating_type?.errors?.required">
      Please select the rating type.
    </div>

    <!-- Mandatory for every quote, whatever the claims-history/rating type -->
    <!-- The question is asked above the field as well as in the floating label: once an
         insurer is picked the label shrinks away, and the broker could no longer see what
         the dropdown was asking. -->
    <ng-container *ngIf="staticData">
      <h6 class="mt-3">Who is the current insurer? <span class="text-danger">*</span></h6>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="w-100">
            <mat-label>Current insurer</mat-label>
            <mat-select formControlName="current_insurer" required
              [ngClass]="{ 'is-invalid': (f.current_insurer?.touched || submitted) && f.current_insurer?.errors?.required }">
              <mat-option value="">Select insurer</mat-option>
              <mat-option *ngFor="let ins of (staticData.insurer_options || [])" [value]="ins">{{ins}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback d-block"
            *ngIf="(f.current_insurer?.touched || submitted) && f.current_insurer?.errors?.required">
            Please select the current insurer.
          </div>
        </div>
      </div>
    </ng-container>
  </div>


  <!-- ═══ NAVIGATION ═══ -->
  <div class="row" *ngIf="frmFields.get('proposer.proposer_type')?.value">
    <div class="col-md-6"></div>
    <div class="col-md-6 text-right">
      <button type="submit" class="btn btn-success btn-sm mb-2">Proceed</button>
    </div>
  </div>

</form>
